import { OPT_IN } from '@v4/constants/questions'
import AppStore from '@v4/store/appStore'
import { useCallback, useMemo, useState } from 'react'
import { getSectionTheme } from '@v4/utils/theme'
import useWordings from '@v4/hooks/useWordings'
import useStyles from './SignUpFormComponent.styled'

export const useSignUpFormComponent = props => {
	const classes = useStyles(props)

	const {
		captchaRef,
		handleSubmit,
		isSubmitting,
		className,
		usePaperColors,
		fieldsPerRow,
		onTitleClick,
		onButtonClick,
		settings: {
			optin,
			firstname_label: firstNameLabel,
			firstname_enabled: firstnameEnabled,
			lastname_enabled: lastnameEnabled,
			lastname_label: lastNameLabel,
			email_label: emailLabel,
			email_enabled: emailEnabled,
			optin_label: optinLabel,
			privacy_wording: privacyWording,
			privacy_policy_url: privacyPolicyUrl,
		},
		titleEditable,
		onTitleChange,
		buttonTextEditable,
		buttonTextConfig,
		onButtonTextChange,
		titleKey,
		buttonTextKey,
		white,
		image,
		onImageClick,
		withCaptcha,
		data,
		buttonText = 'Start',
		title = '',
		titleConfig,
		placeholderColor = 'transparent',
		withOptin = true,
	} = props

	const divider = 12 / (fieldsPerRow || 1)
	const hasOptin = withOptin && optin !== OPT_IN.IMPLIED_CONSENT
	const isScorecardMode = AppStore.useStoreState(state => state.general.isScorecardMode)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const [settingsButtonVisible, setSettingsButtonVisible] = useState(false)
	const { getWording } = useWordings()
	const { getWording: getLeadWording } = useWordings('lead')

	const buttonTheme = useCallback(
		parentTheme =>
			getSectionTheme(parentTheme, {
				palette: {
					backgroundDefault: parentTheme.palette.primary.main,
					backgroundPaper: parentTheme.palette.primary.main,
				},
			}),
		[],
	)

	const handleSettingMouseEnter = useCallback(() => {
		setSettingsButtonVisible(true)
	}, [])

	const handleSettingMouseLeave = useCallback(() => {
		setSettingsButtonVisible(false)
	}, [])

	const newData = useMemo(() => {
		const result = _.reduce(
			data,
			(acc, value, key) => {
				_.forEach(value, item => {
					acc.push({ group: key, question: item })
				})

				return acc
			},
			[],
		)

		return _.sortBy(result, ['question.order'])
	}, [data])

	return [
		{
			captchaRef,
			classes,
			isSubmitting,
			className,
			title,
			titleConfig,
			placeholderColor,
			usePaperColors,
			fieldsPerRow,
			firstNameLabel: getLeadWording(firstNameLabel || 'First Name'),
			firstnameEnabled,
			lastnameEnabled,
			lastNameLabel: getLeadWording(lastNameLabel || 'Last Name'),
			emailLabel: getLeadWording(emailLabel || 'Email'),
			emailEnabled,
			optinLabel,
			privacyWording,
			privacyPolicyUrl,
			data: newData,
			divider,
			hasOptin,
			withHoneyPot: isScorecardMode && !!import.meta.env.VITE_HONEY_POT_FIELD,
			titleEditable,
			buttonText,
			buttonTextEditable,
			buttonTextConfig,
			buttonTheme,
			titleKey,
			buttonTextKey,
			withSettings: isBuilderMode,
			settingsButtonVisible,
			getWording,
			white,
			image,
			withImage: !!image?.image,
			withCaptcha,
		},
		{
			handleSubmit,
			handleTitleClick: onTitleClick,
			handleButtonClick: onButtonClick,
			handleTitleChange: onTitleChange,
			handleButtonTextChange: onButtonTextChange,
			handleSettingMouseEnter,
			handleSettingMouseLeave,
			handleImageClick: onImageClick,
		},
	]
}
